import PaginateModel from "@/model/paginate";
import mDeliveryDestination from "@/model/mDeliveryDestination";
import api from "./api";

interface DeliveryDestinationList {
  list: mDeliveryDestination[];
  paginate: any;
}

class DeliveryDestinationApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getAll(query): Promise<DeliveryDestinationList> {
    const response = await this.getHttp().get<any>("cart-delivery", {
      params: query,
    });

    const list = response.data.data.data.map((userDto) => {
      return new mDeliveryDestination(userDto);
    });

    const paginate = new PaginateModel({
      page: response.data.data.pagination.current_page,
      pageCount: response.data.data.pagination.last_pages,
      start: response.data.data.pagination.current_page,
      end: response.data.data.pagination.last_pages,
      count: response.data.data.pagination.total,
    });
    return {
      list: list,
      paginate: paginate,
    };
  }
  async add(data): Promise<any> {
    const response = await this.getHttp().post("/cart-delivery", data);
    return response.data;
  }
  async update(id, data): Promise<any> {
    const response = await this.getHttp().put("/cart-delivery/" + id, data);
    return response.data;
  }
  async delete(id): Promise<any> {
    const response = await this.getHttp().delete("/cart-delivery/" + id);
    return response.data;
  }
}
export default new DeliveryDestinationApi();
